import { Card } from "@/components/ui/card.tsx";
import type { ReactElement, ReactNode } from "react";
import { cn } from "cn";

interface EmptyStateSlots {
    icon?: ReactElement;
    title?: string;
    description?: string;
    actions?: ReactNode;
}

interface EmptyStateOptions {
    isEmbedded?: boolean;
    className?: string;
}

export type EmptyStateProps = EmptyStateSlots & EmptyStateOptions & ({ icon: ReactElement } | { title: string } | { description: string });

export function EmptyState({ icon, title, description, actions, isEmbedded = false, className }: EmptyStateProps) {
    const isMessageOnly = !icon && !title;
    const layout = cn("flex flex-col items-center justify-center gap-3 px-12 text-center", isMessageOnly ? "py-6" : "py-10");
    const content = (
        <>
            {icon ? (
                <span aria-hidden="true" className="text-muted-fg [&>svg]:size-8">
                    {icon}
                </span>
            ) : null}
            {title ? <p className="text-fg text-sm font-medium">{title}</p> : null}
            {description ? <p className="text-muted-fg text-sm">{description}</p> : null}
            {actions ? <div className="flex flex-wrap items-center justify-center gap-3 pt-1">{actions}</div> : null}
        </>
    );

    if (isEmbedded) {
        return <div className={cn(layout, "h-full", className)}>{content}</div>;
    }

    return <Card className={cn(layout, className)}>{content}</Card>;
}
